export default __webpack_public_path__ + "static/media/undereyePuffiness.646cf711.svg";